





































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { hasValue } from '@/utils/util'
import TaskApi from '@/api/task'
import VisitorApi from '@/api/visitor'
import { setViewer, debounce } from '@/utils/util'
import { Modal } from 'ant-design-vue'
import { Index } from 'mathjs'
const debounceUpload = debounce(100)
let viewer: any = ''
const MAX_FILE_NUM = 20
const MAX_FILE_SIZEM = 10
@Component({
	name: 'MsgBoardDialog',
	components: {},
})
export default class MsgBoardDialog extends Vue {
	@Prop()
	private value!: boolean

	@Prop()
	private orderId!: any

	private visible: boolean = false
	private loading: boolean = false
	private msg: any = ''
	private list: any = []
	private total: any = 0
	private pageSize: any = 20
	private pageNum: any = 1
	private colorMap: any = {
		保险公司: 'color1',
		资源公司: 'color2',
		中保车服: 'color3',
	}

	private fileList: any = []
	private uploading: boolean = false

	@Watch('reason', { immediate: true })
	private openImg(val: any) {
		if (val) {
			this.$nextTick(() => {
				if (val) {
					const dom = document.querySelector('#images')
					if (dom) {
						viewer = setViewer(dom, viewer)
					}
				}
			})
		}
	}

	public beforeUpload(file: any, fileList: any, checkedType: number) {
		debounceUpload(() => {
			this.uploadFileList(fileList, checkedType)
		})

		return false
	}

	public uploadFileList(fileList: any, checkedType: number) {
		if (fileList.length + this.fileList.length > MAX_FILE_NUM) {
			this.$message.error(`最多只能上传${MAX_FILE_NUM}张图片`)
			return
		}
		for (let i = 0; i < fileList.length; i++) {
			let currentFile = fileList[i]
			if (currentFile.size > MAX_FILE_SIZEM * 1024 * 1024) {
				this.$message.error(`${currentFile.name}文件大小超过${MAX_FILE_SIZEM}M`)
				return
			}
		}

		this.uploading = true
		const hide: any = this.$message.loading('上传中...', 0)
		let num = 0
		for (const file of fileList) {
			const formData = new FormData()
			formData.append('filecontent', file)

			VisitorApi.operateAndUpload({
				formData,
				params: {
					cmd: 'imageMogr2/thumbnail/400x',
				},
			})
				.then((res: any) => {
					num++
					this.onPressEnter(res.data.picId, 2)
					if (num === fileList.length) {
						hide()
						this.uploading = false
						this.$message.success('上传完成')
						this.fileList = []
					}
				})
				.catch((err: any) => {
					num++
					this.$message.error(`${file.name}上传失败`)
					if (num === fileList.length) {
						hide()
						this.uploading = false
						this.$message.success('上传完成')
						console.log(err, 'err')
					}
				})
		}
	}

	@Watch('value', { immediate: true })
	private async onValueChange() {
		this.visible = this.value
		if (this.visible) {
			this.pageNum = 1
			const res = await TaskApi.getMsgBoardList({
				orderId: this.orderId,
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			})
			this.list = res.data.retList
			this.total = res.data.count
			this.$nextTick(() => {
				const list: any = this.$refs.list
				list.scrollTo(0, list.scrollHeight)
			})
		}
	}

	private send() {
		this.onPressEnter(this.msg, 1)
	}

	private async onPressEnter(msgInfo: any, type: number) {
		if (hasValue(msgInfo)) {
			const msg = msgInfo
			if (type == 1) {
				this.msg = ''
			}
			await TaskApi.addMsgBoard({
				orderId: this.orderId,
				message: msg,
				messageType: type == 1 ? 'text' : 'image',
			})
			this.pageNum = 1
			const res = await TaskApi.getMsgBoardList({
				orderId: this.orderId,
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			})
			this.list = res.data.retList
			this.total = res.data.count
			this.$nextTick(() => {
				const list: any = this.$refs.list
				list.scrollTo(0, list.scrollHeight)
			})
		} else {
			this.$message.error('请输入内容')
		}
	}

	private async onScroll() {
		const list: any = this.$refs.list
		if (this.list.length < this.total && !this.loading && list.scrollTop < 20) {
			this.loading = true
			const firstChild = list.children[0]
			this.pageNum++
			const res = await TaskApi.getMsgBoardList({
				orderId: this.orderId,
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			})
			this.list = res.data.retList.concat(this.list)
			this.total = res.data.count
			this.$nextTick(() => {
				list.scrollTo(0, firstChild.offsetTop - 10)
			})
			this.loading = false
		}
	}
	rightClick(item: any, index: Index) {
		let _this = this
		if (this.$store.state.user.userInfo.name !== item.creatorName) {
			return
		}
		Modal.confirm({
			title: '提示',
			content: '确定删除该照片？',
			okText: '确认',
			cancelText: '取消',
			async onOk() {
				const res: any = await TaskApi.delBoard(item.id)
				if (res.status === 'success') {
					_this.list.splice(index, 1)
					_this.$message.success('删除成功')
				} else {
					_this.$message.error(res.message)
				}
			},
			onCancel() {
				console.log('Cancel')
			},
		})
	}
}
